import { isDrawingsRelayOperation } from '@sitemax/smx-drawings-web';

const { REACT_APP_DRAWINGS_API_URL } = process.env;

export const graphqlRouterMiddleware = async (args: any, next: any) => {
    const { context } = args;

    if (isDrawingsRelayOperation(args)) {
        context.url = REACT_APP_DRAWINGS_API_URL;
    }

    return next(args);
};
